module.exports = __webpack_public_path__ + "media/control_acceso/backset_axe-7043a8f7.webp";